import React, { useMemo } from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import ListOneColumn from '../ListOneColumn/ListOneColumn';

const ListTwoColumns = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const leftQuestions = useMemo(
    () => filteredQuestions.filter((_, index) => index % 2 === 0),
    [filteredQuestions],
  );
  const rightQuestions = useMemo(
    () => filteredQuestions.filter((_, index) => index % 2 === 1),
    [filteredQuestions],
  );
  return (
    <>
      <ListOneColumn filteredQuestions={leftQuestions} />
      <ListOneColumn filteredQuestions={rightQuestions} />
    </>
  );
};

export default ListTwoColumns;
